import React, { useContext, useEffect, useState } from "react";
import logo from "../resources/mutfaciknewlogo.png";
import { ILoginInfo } from "../models/ILoginInfo";
import { Context } from "../utils/AppContext";
import { useNavigate } from "react-router-dom";
import { getUserDetails } from "../utils/Util";
import { checkIsSuperAdmin } from "../services/checkRole";
import { isLoggedIn, logout, getUserToken, saveAddresses, getRememberMe, saveUserToken, clearUserStorage, getDeviceId, getDefaultAddress } from "../utils/tokenUtils";
import { getTokenForWeb, loginUser } from "../services/auth";
import { getCustomerAddressList } from "../services/customerAddress";
import { useBasket } from "../utils/BasketContext";
import { AUTH_EVENT } from "../modules/LiveChat";
import { useActiveOrder } from "../utils/ActiveOrderContext";
import { useLanguage } from "../context/LanguageContext";
import "../styles/style.css";
import MainHamburgerMenu from "./MainHamburgerMenu";
import OrderTrackingPopup from "../popupPages/OrderTrackingPopup";
import CitySelectPopup from "../popupPages/CitySelectPopup";


function Navbar(props: { user: ILoginInfo }) {
  const [isSuperUser, setIsSuperUser] = useState<boolean>(false);
  const [customerName, setCustomerName] = useState<string | null>(null);
  const [loggedIn, setLoggedIn] = useState<boolean>(isLoggedIn());
  const { basketCount } = useBasket();
  const { activeOrders } = useActiveOrder();
  const { t } = useLanguage();
  const [showCityPopup, setShowCityPopup] = useState(false);

  const context = useContext(Context);
  const Navigate = useNavigate();

  const loadUserInfo = () => {
    getUserDetails().then((userDetails) => {
      if (userDetails) {
        setCustomerName(userDetails.customerName);
        checkIsSuperAdmin(userDetails.id).then((res) => {
          setIsSuperUser(res);
        });
      }
    });

    const tokenObj = getUserToken();
    if (tokenObj) {
      getCustomerAddressList(tokenObj.userId)
        .then((res) => saveAddresses(res.data))
        .catch(() => {});
    }
  };


  // Auto-login: "Beni Hatırla" seçiliyse ve kullanıcı giriş yapmamışsa otomatik giriş yap
  useEffect(() => {
    if (isLoggedIn()) return;
    const saved = getRememberMe();
    if (!saved) return;

    getTokenForWeb().then(() => {
      loginUser(saved.email, saved.password, getDeviceId())
        .then((res) => {
          clearUserStorage();
          saveUserToken({
            token: res.data.token,
            expiration: res.data.expiration,
            secretKey: res.data.secretKey,
            userId: res.data.userId,
            refreshToken: res.data.refreshToken,
            refreshTokenExpiration: res.data.refreshTokenExpiration,
          });
          setLoggedIn(true);
          // Sayfa yenilenmediği için canlı destek oturumun kurulduğunu buradan öğrenir.
          window.dispatchEvent(new CustomEvent(AUTH_EVENT));
        })
        .catch(() => {
          localStorage.removeItem("rememberMe");
        });
    });
  }, []);

  useEffect(() => {
    if (loggedIn) {
      loadUserInfo();
    } else {
      setCustomerName(null);
      setIsSuperUser(false);
    }
  }, [loggedIn]);

  useEffect(() => {
    const handleSessionExpired = () => {
      setLoggedIn(false);
    };
    window.addEventListener("session-expired", handleSessionExpired);
    return () => window.removeEventListener("session-expired", handleSessionExpired);
  }, []);

  const onLoginSuccess = () => {
    if (!getUserToken()) return;
    setLoggedIn(true);
    window.location.reload();
  };

  const fncLogout = () => {
    logout();
    setLoggedIn(false);
    Navigate("/", { replace: true });
  };

  return (
    <>
      <OrderTrackingPopup />
      <nav className="navbar background-red" style={{ border: "none" }}>
        <div className="container-fluid background-red">
          <div className="d-flex align-items-center">
            <button
              className="navbar-toggler border-0 shadow-none d-none d-sm-block"
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasNavbar"
              aria-controls="offcanvasNavbar"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            {basketCount > 0 && (
              <button
                type="button"
                className="btn text-white position-relative ms-2 p-1 d-none d-sm-block"
                data-bs-toggle="modal"
                data-bs-target="#sepetModal"
                aria-label={t("cart.title")}
              >
                <i className="bi bi-cart-fill fs-5"></i>
                <span
                  className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-white text-danger"
                  style={{ fontSize: "0.65rem", fontWeight: 700 }}
                >
                  {basketCount}
                </span>
              </button>
            )}
            {customerName && (
              <span className="text-white ms-2">{t("navbar.welcome", { name: customerName })}</span>
            )}
            <button
              className="btn btn-sm text-white border-0 ms-2 d-flex align-items-center gap-1"
              style={{
                background: "rgba(255,255,255,0.15)",
                borderRadius: "20px",
                padding: "3px 10px",
                fontSize: "0.75rem",
                whiteSpace: "nowrap",
              }}
              onClick={() => {
                if (loggedIn) {
                  Navigate("/adreslerim");
                } else {
                  setShowCityPopup(true);
                }
              }}
            >
              <i className="bi bi-geo-alt-fill"></i>
              <span className="d-none d-sm-inline" style={{ maxWidth: "140px", overflow: "hidden", textOverflow: "ellipsis" }}>
                {loggedIn
                  ? (getDefaultAddress()?.customerAddressDescription || t("navbar.selectAddress"))
                  : (localStorage.getItem("guestLocationName") || t("navbar.selectLocation"))
                }
              </span>
            </button>
          </div>

          <div className="d-flex align-items-center gap-2">
            {activeOrders.length > 0 && (
              <button
                type="button"
                className="btn btn-sm text-white border-0 d-flex align-items-center gap-1 position-relative"
                data-bs-toggle="modal"
                data-bs-target="#orderTrackingModal"
                style={{
                  background: "rgba(255,255,255,0.2)",
                  borderRadius: "20px",
                  padding: "4px 12px",
                  fontSize: "0.78rem",
                  fontWeight: 600,
                  whiteSpace: "nowrap",
                }}
              >
                <i className="bi bi-truck"></i>
                <span className="d-none d-sm-inline">{t("activeOrder.tracking")}</span>
                <span
                  className="badge rounded-pill bg-white text-danger ms-1"
                  style={{ fontSize: "0.65rem", fontWeight: 700 }}
                >
                  {activeOrders.length}
                </span>
              </button>
            )}
            <a className="navbar-brand mb-0" href="/" onClick={(e) => { e.preventDefault(); Navigate("/"); }}>
              <img src={logo} alt="Mutfacik" height="40" />
            </a>
          </div>

          <MainHamburgerMenu
            isSuperUser={isSuperUser}
            fncLogout={fncLogout}
            isLoggedIn={loggedIn}
            onLoginSuccess={onLoginSuccess}
          />
        </div>
      </nav>

      {showCityPopup && <CitySelectPopup onClose={() => setShowCityPopup(false)} />}

      {/* Mobil alt bar — sadece küçük ekranlarda, aktif sipariş varken */}
      {activeOrders.length > 0 && (
        <div
          className="d-block d-sm-none"
          data-bs-toggle="modal"
          data-bs-target="#orderTrackingModal"
          style={{
            position: "fixed",
            bottom: 60,
            left: 0,
            right: 0,
            zIndex: 1050,
            background: "linear-gradient(135deg, #FF9800, #F57C00)",
            color: "#fff",
            padding: "10px 16px",
            boxShadow: "0 -2px 12px rgba(0,0,0,0.2)",
            cursor: "pointer",
          }}
        >
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center gap-2">
              <i className="bi bi-truck" style={{ fontSize: "1.2rem" }}></i>
              <div>
                <div style={{ fontSize: "0.82rem", fontWeight: 700 }}>
                  {t("activeOrder.mobileBarTitle", { count: activeOrders.length })}
                </div>
                <div style={{ fontSize: "0.7rem", opacity: 0.85 }}>
                  {activeOrders[0]?.orderStatus?.orderStatusNameTr}
                  {activeOrders.length > 1 && ` +${activeOrders.length - 1}`}
                </div>
              </div>
            </div>
            <div
              style={{
                background: "rgba(255,255,255,0.25)",
                borderRadius: "20px",
                padding: "5px 14px",
                fontSize: "0.78rem",
                fontWeight: 700,
              }}
            >
              {t("activeOrder.mobileBarAction")} <i className="bi bi-chevron-right ms-1"></i>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Navbar;
